import React, { useState } from 'react'
// React Router
import { useNavigate } from 'react-router-dom'
// Ant Design
import { Flex, Typography, Button, Drawer, Input, message, Alert } from 'antd'
// Ant Design Icons
import { PlusOutlined } from '@ant-design/icons'
// Axios
import axios from 'axios'
// Config
import config from '../../config'
import { getConfig } from '../../config'

const { Title } = Typography

export const Header = ({ t, isCreated, setIsCreated }) => {
    const [name, setName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [open, setOpen] = useState(false)
    const [men, setMen] = useState("")
    const [loading, setLoading] = useState(false)

    const [messageApi, contextHolder] = message.useMessage()
    const navigate = useNavigate()
    
    const showDrawer = () => setOpen(true)
    const onClose = () => setOpen(false)

    const onCreate = async() => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
        const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/

        if (name==="" || lastName==="" || email==="" || password==="" || confirmPassword==="") {
            setMen(t("fields_required"))
        }
        else if(!emailRegex.test(email)) {
            setMen(t("email_error"))
        }
        else if(password !== confirmPassword) {
            setMen(t("not_ditto_pass"))
        }
        else if(password.length<8) {
            setMen(t("pass_length"))
        }
        else if(!passRegex.test(password)) {
            setMen(t("pass_complexity"))
        }
        else {
            setLoading(true)
            try {
                const res = await axios.post(config.urlApi + "/private/users", {
                    full_name: name + " " + lastName,
                    password: password,
                    email: email,
                    is_admin: false
                })
                if(res.status===201) {
                    messageApi.success(t("user_created"))
                    setName("")
                    setLastName("")
                    setEmail("")
                    setPassword("")
                    setConfirmPassword("")
                    setOpen(false)
                    setLoading(false)
                    setIsCreated(!isCreated)
                    setMen("")
                }
            }
            catch (error) {
                setLoading(false)
                if(error.status===413) {
                    messageApi.error(t("error_413_users"))
                }
                else if(error.status===409) {
                    messageApi.error(t("error_409_users"))
                }
                else if (error.status === 401) {
                    navigate("/")
                }
                else {
                    messageApi.error(t("error_create_user"))
                }
            }
        }
    }

    return (
        <Flex align="center" style={{ width: "100%", height: "60px", borderBottom: `2px solid ${getConfig("colorPrimario")}` }}>
            <Title level={3} style={{ marginBottom: "0" }}>{t("list_users")}</Title>
            <Button onClick={showDrawer} icon={<PlusOutlined />} style={{ marginLeft: "auto", color: getConfig("colorSecundario"), border: `1.5px solid ${getConfig("colorSecundario")}` }}>{t("add")}</Button>
        
            <Drawer title={t("add_user")} onClose={onClose} open={open}>
                <Flex vertical>
                    <Input onChange={(e) => setName(e.target.value)} value={name} size="large" style={{ marginBottom: "20px" }} placeholder={t("name")} />
                    <Input onChange={(e) => setLastName(e.target.value)} value={lastName} size="large" style={{ marginBottom: "20px" }} placeholder={t("last_name")} />
                    <Input onChange={(e) => setEmail(e.target.value)} value={email} size="large" style={{ marginBottom: "20px" }} placeholder={t("email")} />
                    <Input.Password onChange={(e) => setPassword(e.target.value)} value={password} size="large" style={{ marginBottom: "20px" }} placeholder={t("password")} />
                    <Input.Password onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} size="large" style={{ marginBottom: "5px" }} placeholder={t("confirm_password")} />
                    <span style={{ fontSize: "11px", marginBottom: "10px", color: "#888", textAlign: "justify" }}>{t("password_must")}</span>      
                    <Button onClick={onCreate} loading={loading} ghost style={{ marginTop: "10px", color: getConfig("colorPrimario"), border: `1.5px solid ${getConfig("colorPrimario")}` }}>{t("create")}</Button>
                    {men!=="" && <Alert message={men} type="error" closable onClose={() => setMen("")} style={{ marginTop: "20px" }} />}
                </Flex>
            </Drawer>

            {contextHolder}
        </Flex>
    )
}
